export enum MessageNotificationProgress {
  Unread = 'Unread',
  Read = 'Read'
}
